module.exports = new __parcel__URL__("european-name-badge.88b6d02d.svg").toString();